import { ReactElement } from "react";
import {
  IContentAreaProps,
  IDataContext,
  IIndicator,
  IMenuButton,
  IQueryController,
  IViewController
} from "../../types";
import { Alert } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import HeatInformation from "./components/heatInformation";
import LRFHeatInformation from "../meltShop/lrf/lrfHeatInformation";
import CasterHeatInformation from "../meltShop/caster/casterHeatInformation";
import ProductionInformation from "../mill/components/productionInformation";
import FullInformation from "./components/fullInformation";

import ProductionPage from "./productionPage";
import ProductionGantt from "./components/productionGantt";
import IndicatorA from "./components/indicators/indicatorA";


class Module implements IQueryController, IViewController {

  private ganttButton: IMenuButton = {
    title: "Gantt",
    icon: <FormatListBulletedIcon/>,
    color: "blue",
    dataContext: {
      title: "Gantt",
      module: "production",
      subModule: "gantt"
    }
  };

  private productionButton: IMenuButton = {
    title: "Production",
    icon: <TrendingUpIcon/>,
    color: "green",
    disabled: true,
    dataContext: {
      title: "Production",
      module: "production",
      subModule: "production"
    }
  };

  private productionGroupButton: IMenuButton = {
    title: "Production",
    icon: <TrendingUpIcon/>,
    color: "green",
    disabled: true,
    children: [this.ganttButton, this.productionButton],
    dataContext: {
      title: "Production",
      module: "production",
      subModule: "productionGroup"
    }
  };

  private buttons = [this.productionGroupButton, this.productionButton, this.ganttButton];

  getModuleName(): string{
    return "production";
  }

  onDataArrived(data: any[]): ReactElement {

    if (!data || data.length === 0) {
      return <Alert severity="warning">No Data to Display.</Alert>;
    }

    if (data.length === 1) {
      if ( data[0].__typename === "EAFProduction") {
        return <HeatInformation productionItem={data[0]}/>;
      }

      if ( data[0].__typename === "LRFProduction") {
        return <LRFHeatInformation productionItem={data[0]}/>;
      }

      if ( data[0].__typename === "CasterProduction") {
        return <CasterHeatInformation productionItem={data[0]}/>;
      }

      if ( data[0].__typename === "StrandProduction") {
        return <ProductionInformation productionItem={data[0]}/>;
      }
    }

    return <FullInformation productionItems={data} height={600} />;
  }

  getView (dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    if (dataContext.subModule === "production") {
      return <ProductionPage/>;
    }

    return <ProductionGantt parentSize={props.parentSize} dataContext={dataContext}/>;
  }

  getButtons(): IMenuButton[] {
    return [this.ganttButton, this.productionButton];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "indicatorA") {
      return <IndicatorA dataContext={dataContext} />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
